import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

// Project and dataset ids are public identifiers, not secrets. The dataset is
// read-only to the public; nothing can be written from the website.
export const SANITY_PROJECT_ID = "yd4wofop";
export const SANITY_DATASET = "production";
export const SANITY_API_VERSION = "2025-01-01";

const client = createClient({
  projectId: SANITY_PROJECT_ID,
  dataset: SANITY_DATASET,
  apiVersion: SANITY_API_VERSION,
  useCdn: true,
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);

// A shoot story is only shown once the client's permission is ticked in the
// Studio. Documents still in draft are never returned to the public.
const LIVE =
  '_type == "post" && defined(slug.current) && publishedAt <= now() && (kind != "story" || permissionConfirmed == true)';

const CARD = `{
  title,
  "slug": slug.current,
  kind,
  category,
  excerpt,
  publishedAt,
  heroImage{ asset, hotspot, crop, alt }
}`;

export const fetchPosts = () =>
  client.fetch(`*[${LIVE}] | order(publishedAt desc) ${CARD}`);

export const fetchPost = (slug) =>
  client.fetch(
    `*[${LIVE} && slug.current == $slug][0]{
      title,
      "slug": slug.current,
      kind,
      category,
      excerpt,
      metaDescription,
      publishedAt,
      _updatedAt,
      heroImage{ asset, hotspot, crop, alt },
      body[]{
        ...,
        _type == "image" => { ..., asset, hotspot, crop, alt, caption }
      },
      gallery[]{ asset, hotspot, crop, alt }
    }`,
    { slug },
  );

export const fetchRelated = (slug) =>
  client.fetch(
    `*[${LIVE} && slug.current != $slug] | order(publishedAt desc)[0...3] ${CARD}`,
    { slug },
  );
